"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vf_trigger_1 = require("./vf-trigger");
var babylonjs_1 = require("babylonjs");
var vf_material_factory_1 = require("./util/vf-material-factory");
var const_1 = require("./util/const");
var logger_1 = require("./util/logger");
var vf_scene_state_1 = require("./enums/vf-scene-state");
var VFEgoTrigger = (function (_super) {
    __extends(VFEgoTrigger, _super);
    function VFEgoTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VFEgoTrigger.prototype.onClick = function (byCode) {
        if (byCode === void 0) { byCode = false; }
        logger_1.default.debug(this.name + ".onClick()");
        if (byCode === false) {
            this.scene.didActivateTrigger(this.triggerMeta.type, this.triggerMeta.name);
        }
        var rotation = null;
        if (this.triggerMeta.lookDirection != null) {
            var angle = this.triggerMeta.lookDirection;
            logger_1.default.debug("Look Direction: " + angle);
            rotation = babylonjs_1.Quaternion.FromEulerAngles(0, babylonjs_1.Tools.ToRadians(angle), 0);
        }
        if (this.scene.sceneState !== vf_scene_state_1.VFSceneState.EgoPerspective) {
            this.scene.onEgoInit(this.cameraPosition, rotation);
        }
        else {
            this.scene.egoCamera.moveTo(this.cameraPosition, rotation);
        }
    };
    VFEgoTrigger.prototype.getMaterial = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, vf_material_factory_1.default.GetEgoTriggerMaterial(this.scene, this.triggerMeta.customButtonTextureHash, this.customColor)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Object.defineProperty(VFEgoTrigger.prototype, "cameraPosition", {
        get: function () {
            var pos = this.node.getAbsolutePosition().clone();
            if (this.mesh != null) {
                pos = this.mesh.getAbsolutePosition().clone();
            }
            pos.addInPlace(this.getPositionOffset());
            return pos;
        },
        enumerable: true,
        configurable: true
    });
    VFEgoTrigger.prototype.getPositionOffset = function () {
        var eyeHeight = const_1.default.EGO_EYE_LEVEL;
        if (this.properties) {
            if (this.properties["eye_height"] != null) {
                eyeHeight = this.properties["eye_height"];
            }
        }
        return new babylonjs_1.Vector3(0, eyeHeight * this.scene.model.scaleFactor, 0);
    };
    return VFEgoTrigger;
}(vf_trigger_1.default));
exports.default = VFEgoTrigger;
